<div class="max-w-8xl mx-auto px-1 sm:px-2 py-2">


    <!-- Reviews Tab -->
    <div *ngIf="activeTab == 'reviews'" class="tab-content">
        <div class="bg-white shadow-sm border rounded-md p-1.5 mb-4">
            <div class="flex justify-between items-center mb-1 pb-1 border-b border-gray-100">
                <h2 class="text-sm font-semibold text-gray-800 flex items-center">
                    <i class="pi pi-verified text-blue-500 mr-2"></i> Proposal Reviews
                </h2>
                <div class="flex gap-1">
                    <button
                        class="bg-blue-600 hover:bg-blue-700 text-white text-xs font-medium py-0.5 px-2 rounded flex items-center transition"
                        (click)="addEquipment()">
                        <i class="pi pi-plus-circle text-xs mr-1"></i> Review Points
                    </button>
                    <button
                        class="bg-blue-600 hover:bg-blue-700 text-white text-xs font-medium py-0.5 px-2 rounded flex items-center disabled:opacity-50 transition"
                        [disabled]="!selectedProposals || selectedProposals.length === 0" (click)="openReviewDialog()">
                        <i class="fa-solid fa-paper-plane text-xs mr-1"></i> Send
                    </button>
                </div>
            </div>

            <p-table [value]="proposals" dataKey="id" [(selection)]="selectedProposals" [paginator]="true" [rows]="10"
                [tableStyleClass]="'w-full text-xs'" class="compact-p-table-wrapper mt-1">
                <ng-template pTemplate="header">
                    <tr class="text-left font-semibold text-gray-600 border-b border-gray-200 text-[12px]">
                        <th class="w-7 p-1 text-center"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
                        <th class="p-1.5">Date</th>
                        <th class="p-1.5">Challenge</th>
                        <th class="p-1.5">Action</th>
                        <th class="p-1.5">Flag</th>
                        <th class="p-1.5">Directorate</th>
                        <th class="p-1.5 w-12 text-center">Tools</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-proposal>
                    <tr [pSelectableRow]="proposal"
                        class="hover:bg-slate-50 text-gray-700 text-[12px] border-b border-gray-100">
                        <td class="p-1 text-center"><p-tableCheckbox [value]="proposal"></p-tableCheckbox></td>
                        <td class="p-1.5">
                            <ng-container *ngIf="!proposal.isEditMode; else editDate">
                                {{ proposal.review_date || '-' }}
                            </ng-container>
                            <ng-template #editDate>
                                <input type="date" [(ngModel)]="proposal.reviewDate"
                                    class="w-20 px-0.5 py-0.5 border border-gray-300 rounded text-xs" />
                            </ng-template>
                        </td>
                        <td class="p-1.5 text-pretty">{{proposal.challenge}}</td>
                        <td class="p-1.5 text-pretty">{{ proposal.action_point || '-' }}</td>
                        <td class="p-1.5 text-center">{{ proposal.flag || '-' }}</td>
                        <td class="p-1.5">
                            <div class="flex flex-wrap gap-0.5 text-ellipsis">
                                <span *ngFor="let name of getDirectorateNames(proposal.directorate); let i = index">
                                    {{ name || '-' }}<span
                                        *ngIf="i < getDirectorateNames(proposal.directorate).length - 1">,</span>
                                </span>
                            </div>
                        </td>
                        <td class="p-1.5 flex gap-1 items-center justify-center">
                            <button *ngIf="!proposal.isEditMode"
                                class="p-1 rounded-full bg-slate-100 hover:bg-blue-100 text-blue-600 shadow-sm transition"
                                (click)="updateEquipment(proposal)" title="Edit">
                                <i class="fa-regular fa-pen-to-square"></i>
                            </button>
                            <button *ngIf="proposal.isEditMode"
                                class="p-1 rounded-full bg-slate-100 hover:bg-green-100 text-green-600 shadow-sm transition"
                                (click)="saveReview(proposal)" title="Save">
                                <i class="pi pi-check-circle"></i>
                            </button>
                        </td>
                        <td class="p-1.5 flex gap-1 items-center justify-center">
                            <button *ngIf="!proposal.isEditMode"
                                class="p-1 rounded-full bg-slate-100 hover:bg-blue-100 text-blue-600 shadow-sm transition"
                                (click)="updateEquipment(proposal)" title="Edit">
                                <i class="fa-regular fa-pen-to-square"></i>
                            </button>
                            <button *ngIf="proposal.isEditMode"
                                class="p-1 rounded-full bg-slate-100 hover:bg-green-100 text-green-600 shadow-sm transition"
                                (click)="saveReview(proposal)" title="Save">
                                <i class="pi pi-check-circle"></i>
                            </button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>

    <!-- Dialog for Send to Directorate -->
    <p-dialog header="Send to Directorate" [(visible)]="displayReviewDialog" [modal]="true" [closable]="true"
        [style]="{width: '370px'}" class="tailwind-dialog-compact">
        <div class="p-fluid mt-1 mb-2">
            <div class="p-field mt-1">
                <label for="dept" class="text-xs font-medium text-gray-700 block mb-1">
                    <i class="fa-solid fa-building-columns text-sky-700 mr-1"></i> Directorate
                </label>
                <p-multiSelect [options]="unitList" [(ngModel)]="selectedDept" optionLabel="name" optionValue="id"
                    display="chip" appendTo="body" placeholder="Select Directorate" class="p-inputtext-sm w-full">
                </p-multiSelect>
            </div>
            <div class="mt-3 flex justify-end">
                <button (click)="submitReviewPoints()"
                    class="bg-blue-600 hover:bg-blue-700 text-white text-xs font-medium py-1 px-3 rounded disabled:opacity-50 flex items-center"
                    [disabled]="!selectedDept">
                    <i class="fa-solid fa-paper-plane mr-1 text-xs"></i> Submit
                </button>
            </div>
        </div>
    </p-dialog>

    <!-- Monitoring Tab -->
    <div *ngIf="activeTab == 'monitoring'" class="tab-content">
        <div class="bg-white shadow-sm border rounded-md p-1.5">
            <div class="flex items-center justify-between mb-3 px-0.5">
                <h2 class="text-base font-bold text-sky-700 tracking-tight flex items-center gap-2">
                    <span
                        class="inline-flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 shadow text-sky-700 mr-1">
                        <i class="pi pi-desktop"></i>
                    </span>
                    Monitoring Table
                </h2>
                <div class="flex items-center gap-2">
                    <button (click)="openAddColumnDialog()"
                        class="flex items-center gap-1 bg-blue-500 hover:bg-blue-600 text-white text-xs font-semibold py-1.5 px-3 rounded shadow transition">
                        custom columns
                    </button>
                    <input type="text" [(ngModel)]="globalSearch" (input)="applyFilter()"
                        class="w-36 md:w-48 text-xs px-2 py-2 border border-slate-300 rounded-md outline-none transition focus:ring-2 focus:ring-blue-400 shadow-inner bg-white placeholder-slate-400"
                        placeholder="🔍 Search columns or data..." />

                    <button
                        class="flex items-center gap-1 bg-green-500 hover:bg-green-600 text-white text-xs font-semibold py-1.5 px-3 rounded shadow transition"
                        (click)="downloadExcel()" pTooltip="Download as Excel">
                        <i class="pi pi-file-excel"></i>
                        <span class="hidden sm:inline">Export Excel</span>
                    </button>
                </div>
            </div>
            <div class="overflow-x-auto">
                <table class="min-w-full text-sm border-collapse border border-gray-200">
                    <thead class="bg-blue-950">
                        <tr>
                            <th class="p-1 font-semibold w-16 text-center  text-white">Actions</th>
                            <th *ngFor="let col of selectedColumns; let i = index" appResizableColumn [columnIndex]="i"
                                [class]="col === 'Ser' ? 'text-white w-[50px] min-w-[50px] max-w-[50px]' : 'text-white'">
                                <div class="p-2.5 flex items-center gap-1">
                                    <i class=" text-white text-sm"></i>
                                    <!-- <span class="text-nowrap text-sm">{{ tableColumns[i] }}</span> -->
                                    <span class="text-nowrap text-sm">{{ col }}</span>
                                </div>
                            </th>
                        </tr>
                        <tr>
                            <th></th>
                            <th *ngFor="let col of selectedColumns; let i = index"
                                [class]="col === 'Ser' ? 'w-[50px] min-w-[50px] max-w-[50px]' : ''">
                                <input type="text" [(ngModel)]="columnFilters[col]" (input)="applyFilter()"
                                    class="w-full text-xs p-1 border border-gray-200 rounded-sm focus:outline focus:ring-1 focus:ring-blue-300"
                                    [placeholder]="'Filter ' + col" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of paginatedData; let r = index"
                            [ngClass]="{ 'bg-white': r % 2 === 0, 'bg-slate-200': r % 2 !== 0 }"
                            class="hover:bg-blue-50 transition">

                            <td
                                class="p-1 text-center whitespace-nowrap flex  gap-2 items-center justify-center min-w-[46px]">
                                <button
                                    class="bg-green-100 border-2 border-green-600 text-green-600 hover:bg-green-200 rounded p-1"
                                    (click)="onSubmit(row)" [disabled]="isRowEmpty(row)" pTooltip="Save">
                                    <span class="flex items-center justify-center h-4 w-4">
                                        <i class="pi pi-save group-hover:scale-110 transition-transform"></i>
                                    </span>

                                </button>
                                <button
                                    class="bg-green-100 border-2 border-green-600 text-green-600 hover:bg-green-200 rounded p-1"
                                    (click)="connectReview(row)" [disabled]="isRowEmpty(row)" pTooltip="Connect Review">

                                    <span class="flex items-center justify-center h-4 w-4">
                                        <i class="pi pi-link group-hover:scale-110 transition-transform"></i>
                                    </span>

                                </button>
                                <!-- <button
                                    class="bg-slate-100 border-2 border-slate-600 text-slate-600 hover:bg-slate-200 rounded p-1"
                                    (click)="openViewCommentPopup(r, row)"
                                >
                                    <span class="flex items-center justify-center h-4 w-4">
                                        <i class="fa-regular fa-comment group-hover:text-yellow-200 transition-colors"></i>
                                    </span>
                                   
                                </button> -->
                            </td>
                            <td *ngFor="let col of selectedColumns; let c = index"
                                [class]="col === 'Ser' ? 'p-1 border border-gray-400 max-h-24 overflow-hidden w-[50px] min-w-[50px] max-w-[50px]' : 'p-1 border border-gray-400 max-h-24 overflow-hidden max-w-[180px]'">
                                <!-- Editable columns (text input) -->
                                <textarea *ngIf="editableColumns.includes(col) && !dateColumns.includes(col)" rows="3"
                                    [(ngModel)]="row[col]"
                                    class="w-full min-w-[120px] text-xs p-1 border border-gray-300 rounded focus:ring-1 focus:ring-blue-400 focus:outline-none bg-white max-h-20 overflow-y-auto resize-none"
                                    [placeholder]="col"></textarea>

                                <!-- Editable columns (date input) -->
                                <input *ngIf="editableColumns.includes(col) && dateColumns.includes(col)" type="date"
                                    [(ngModel)]="row[col]"
                                    class="w-full text-xs p-1 border border-gray-300 rounded focus:ring-1 focus:ring-blue-400 focus:outline-none bg-white" />

                                <!-- Read-only date columns (from API) -->
                                <span *ngIf="!editableColumns.includes(col) && dateColumns.includes(col)"
                                    class="bg-slate-100 border border-gray-200 rounded-sm p-1 text-xs block">
                                    <i class="pi pi-calendar text-gray-500 text-xs mr-1"></i> {{ row[col] || '-' }}
                                </span>

                                <!-- Read-only text columns (from API) -->

                                <span *ngIf="!editableColumns.includes(col) && !dateColumns.includes(col)">

                                    <div *ngIf="row[col + '_hasValue']"
                                        class="text-[11px] leading-tight space-y-2 bg-gray-50 p-2 rounded min-w-[320px]">
                                        <!-- Disbursed Amount -->
                                        <div class="grid grid-cols-2 gap-2 items-center">
                                            <span class="text-green-600 font-medium">
                                                Disbursed Amount - ₹{{ row[col]?.disbursed }}
                                            </span>
                                        </div>

                                        <!-- Actual Date -->
                                        <div class="grid grid-cols-2 gap-2 items-center">
                                            <span class="text-blue-600 font-medium">
                                                Actual Date - {{ row[col]?.actual }}
                                            </span>
                                        </div>

                                        <!-- Status -->
                                        <div class="grid grid-cols-2 gap-2 items-center">
                                            <span class="text-purple-600 font-medium">
                                                Status - {{ row[col]?.status }}
                                            </span>
                                        </div>

                                        <!-- Expected Amount -->
                                        <div class="grid grid-cols-2 gap-2 items-center">
                                            <span class="text-orange-600 font-medium">
                                                EXP Amt - ₹{{ row[col]?.wbsAmount }}
                                            </span>
                                        </div>

                                        <!-- Expected Date -->
                                        <div class="grid grid-cols-2 gap-2 items-center">
                                            <span class="text-red-600 font-medium">
                                                EXP Date - {{ row[col]?.wbsDate }}
                                            </span>
                                        </div>

                                    </div>

                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Pagination Controls -->
            <div *ngIf="filteredData.length > 0"
                class="flex flex-col sm:flex-row items-center justify-between gap-3 mt-4 px-2 py-3 border-t border-gray-200 bg-gray-50">
                <div class="flex items-center gap-2 text-xs text-gray-600">
                    <span>Showing {{ startIndex }} to {{ endIndex }} of {{ totalItems }} entries</span>
                    <select [(ngModel)]="itemsPerPage" (change)="onItemsPerPageChange()"
                        class="text-xs px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-400">
                        <option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
                    </select>
                    <span class="text-xs">per page</span>
                </div>

                <div class="flex items-center gap-1">
                    <button (click)="previousPage()" [disabled]="currentPage === 1"
                        class="px-3 py-1.5 text-xs font-medium text-gray-700 bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition"
                        title="Previous Page">
                        <i class="pi pi-chevron-left"></i>
                    </button>

                    <div class="flex items-center gap-1">
                        <button *ngFor="let page of getPageNumbers()" (click)="goToPage(page)"
                            [class.bg-blue-600]="page === currentPage" [class.text-white]="page === currentPage"
                            [class.bg-white]="page !== currentPage" [class.text-gray-700]="page !== currentPage"
                            class="px-3 py-1.5 text-xs font-medium border border-gray-300 rounded hover:bg-gray-50 transition min-w-[36px]">
                            {{ page }}
                        </button>
                    </div>

                    <button (click)="nextPage()" [disabled]="currentPage === totalPages"
                        class="px-3 py-1.5 text-xs font-medium text-gray-700 bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition"
                        title="Next Page">
                        <i class="pi pi-chevron-right"></i>
                    </button>
                </div>
            </div>

            <!-- No data message -->
            <div *ngIf="filteredData.length === 0" class="text-center py-8 text-gray-500 text-sm">
                <i class="pi pi-inbox text-4xl mb-2 block"></i>
                <p>No data found</p>
            </div>
        </div>
    </div>
</div>


<div *ngIf="isAddColumnDialogVisible"
    class="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-50 flex items-center justify-center p-4">
    <div
        class="bg-white rounded-xl shadow-2xl border border-slate-200 w-full max-w-4xl overflow-hidden animate-in fade-in zoom-in duration-200">

        <div class="flex items-center justify-between bg-slate-50 px-5 py-3 border-b border-slate-200">
            <div class="flex items-center gap-2">
                <div class="bg-blue-600 p-1.5 rounded-lg">
                    <i class="pi pi-table text-white text-xs"></i>
                </div>
                <h3 class="text-sm font-bold text-slate-800">Column Configuration</h3>
            </div>
        </div>

        <div class="p-4 border-b border-slate-100 flex flex-col sm:flex-row gap-3 items-center justify-between">
            <div class="relative w-full sm:w-72">
                <i class="pi pi-search absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-xs"></i>
                <input type="text" [(ngModel)]="columnSearchText" placeholder="Search columns..."
                    class="w-full pl-9 pr-3 py-1.5 text-xs border border-slate-200 rounded-lg outline-none focus:ring-2 focus:ring-blue-500/20" />
            </div>
            <div class="flex gap-4">
                <button (click)="selectAll()"
                    class="text-[11px] font-bold text-blue-600 hover:text-blue-800 transition-colors uppercase tracking-wider">
                    Select All
                </button>
                <button (click)="resetDefault()"
                    class="text-[11px] font-bold text-slate-500 hover:text-slate-800 transition-colors uppercase tracking-wider">
                    Reset Default
                </button>
            </div>
        </div>

        <div class="p-5 max-h-[50vh] overflow-y-auto">
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">

                <div *ngFor="let col of filteredColumns" (click)="toggleColumn(col)"
                    class="flex items-center gap-2 p-2 rounded-lg cursor-pointer transition-all border border-transparent hover:bg-blue-50"
                    [ngClass]="{'bg-blue-50/50 border-blue-100': isColumnSelected(col)}">

                    <div class="relative flex items-center">
                        <input type="checkbox" [checked]="isColumnSelected(col)"
                            class="w-4 h-4 rounded border-slate-300 text-blue-600 pointer-events-none" />
                    </div>
                    <span class="text-[11px] font-medium text-slate-600 truncate">
                        {{ col }}
                    </span>
                </div>

            </div>
        </div>

        <div class="flex items-center justify-end gap-3 px-5 py-3 bg-slate-50 border-t border-slate-200">
            <span class="text-[10px] text-slate-500 mr-auto font-medium italic">
                {{ selectedColumns.length }} of {{ tableColumns.length }} columns selected
            </span>
            <button (click)="isAddColumnDialogVisible = false"
                class="px-4 py-1.5 text-xs font-bold text-slate-600 hover:bg-slate-200 rounded-lg">
                Cancel
            </button>
            <!-- <button (click)="applyChanges()" class="px-5 py-1.5 text-xs font-bold bg-blue-600 text-white hover:bg-blue-700 rounded-lg shadow-sm">
          Apply Changes
        </button> -->
        </div>

    </div>
</div>